import AvailabilitySchedule from "./EditAvailability";

export default AvailabilitySchedule;
